<template>
  <div class="container">
    <div class="main clearfix">
      <div class="title">我的作品库</div>
      <div class="table">
        <!-- <el-table :data="tableData" style="width: 100%">
          <el-table-column
            show-overflow-tooltip
            property="songName"
            label="歌曲名称"
            min-width="446"
            label-class-name="tableSongName"
          >
            <template slot-scope="scope">
              <div class="songNameContent">
                {{ scope.row.songName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip property="" label="">
            <template> </template>
          </el-table-column>
          <el-table-column property="duration" label="时长" width="80">
            <template slot-scope="scope">
              {{ changeTime(scope.row.songDuration) }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip property="" label="">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="totalCount"
            label="获得人气"
            align="right"
            width="100"
          >
            <template slot-scope="scope">
              <div class="totalCount">
                {{ scope.row.totalCount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip property="" label="">
          </el-table-column>
          <el-table-column property="address" label="操作" min-width="220">
            <template slot-scope="scope">
              <div class="edit" @click="edit(scope.row)">
                <div class="edit_icon"></div>
                <span>编辑</span>
              </div>
              <div class="audition" @click="audition(scope.row)">
                <div class="audition_icon"></div>
                <span>试听</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip property="" label="">
          </el-table-column>
          <el-table-column
            property="address"
            label=""
            align="right"
            min-width="130"
          >
            <template slot-scope="scope">
              <div class="del" @click="del(scope.row)">
                <div class="del_icon"></div>
                <span>删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table> -->
        <div class="table_head">
          <div class="h_1">歌曲名称</div>
          <div class="h_2">时长</div>
          <div class="h_3">获得人气</div>
          <div class="h_"></div>
          <div class="h_4">操作</div>
          <div class="h_"></div>

          <div class="h_5"></div>
        </div>
        <div class="table_body" v-if="tableData.length > 0">
          <div class="items" v-for="(item, index) in tableData" :key="index">
            <div class="b_1">{{ item.songName }}</div>
            <div class="b_2">{{ changeTime(item.songDuration) }}</div>
            <div class="b_3">{{ item.totalCount }}</div>
            <div class="b_"></div>
            <div class="b_4">
              <div class="edit" @click="edit(item)">
                <div class="edit_icon"></div>
                <span>编辑</span>
              </div>
              <div class="audition" @click="audition(item)">
                <div class="audition_icon"></div>
                <span>试听</span>
              </div>
            </div>
            <div class="b_"></div>

            <div class="b_5">
              <div class="del" @click="del(item)">
                <div class="del_icon"></div>
                <span>删除</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="no_data">没有数据啦~</p>
    </div>
    <div class="del_dialog">
      <el-dialog :visible.sync="delDialog" width="520px">
        <div class="head">{{ songName }}</div>
        <div class="body clearfix">
          <p>作品删除后不可恢复 您确定要删除吗?</p>
        </div>
        <div class="foot clearfix">
          <div class="sure" @click="sureDel">
            删除
          </div>
          <div class="cancel" @click="delDialog = false">取消</div>
        </div>
      </el-dialog>
    </div>
    <div class="audition_dialog" @close="closeAuditionDialog">
      <el-dialog
        :visible.sync="auditionDialog"
        :show-close="false"
        top="50vh"
        center
        width="300px"
      >
        <audio
          v-if="auditionDialog"
          id="audio"
          controls="controls"
          ref="audio"
          :src="songUrl"
        ></audio>
      </el-dialog>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import tabBar from "../components/tabBar";
import { SToM } from "../../utils/index";

import { getSongList, delSong } from "../../api/index";
export default {
  components: { tabBar },
  data() {
    return {
      tableData: [],
      songName: "",
      songId: "",
      delDialog: false,
      auditionDialog: false,
      songUrl: ""
    };
  },
  created() {
    this.getSongList();
  },
  mounted() {},
  methods: {
    closeAuditionDialog() {
      this.auditionDialog = false;
    },
    async getSongList() {
      let res = await getSongList();
      this.tableData = res.data.data.items;
    },
    edit(row) {
      this.$router.push({
        path: "/update",
        query: {
          songId: row.songId
        }
      });
      console.log(row);
    },
    async sureDel() {
      this.$openLoading();
      let res = await delSong({ songId: this.songId });
      if (res.data.code == 200) {
        this.$closeLoading();
        this.delDialog = false;
        this.getSongList();
        this.$message({
          type: "success",
          message: "删除成功"
        });
      }
    },
    del(row) {
      this.delDialog = true;
      this.songName = row.songName;
      this.songId = row.songId;
    },
    audition(row) {
      this.auditionDialog = true;
      this.songUrl = row.songUrl;
    },
    changeTime(val) {
      return SToM(val || 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  width: 100%;
  .table_head {
    width: 100%;
    display: flex;
    height: 60px;
    line-height: 60px;
    background: rgba(240, 240, 240, 1);
    font-size: 20px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    color: rgba(38, 33, 33, 1);
    .h_1 {
      flex: 3;
      padding: 0 40px;
    }
    .h_ {
      flex: 1;
    }
    .h_2 {
      flex: 1;
      max-width: 100px;
    }
    .h_3 {
      flex: 1;
      text-align: right;
      max-width: 150px;
    }
    .h_4 {
      flex: 2;
    }
    .h_5 {
      flex: 1;
    }
  }
  .table_body {
    width: 100%;
    .items {
      width: 100%;
      display: flex;
      height: 60px;
      line-height: 60px;
      background: rgba(254, 255, 254, 1);
      border-bottom: 1px solid #ccc;
      font-size: 20px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      color: rgba(128, 124, 124, 1);
      .b_1 {
        flex: 3;
        padding: 0 40px;
        overflow: hidden; /*超出部分隐藏*/
        text-overflow: ellipsis; /* 超出部分显示省略号 */
        white-space: nowrap; /*规定段落中的文本不进行换行 */
      }
      .b_ {
        flex: 1;
      }
      .b_2 {
        flex: 1;
        max-width: 100px;
      }
      .b_3 {
        flex: 1;
        text-align: right;
        max-width: 150px;
      }
      .b_4 {
        flex: 2;
      }
      .b_5 {
        flex: 1;
      }
    }
  }
}
.table /deep/ .empty {
  padding: 0;
}
.table /deep/ .tableSongName {
  padding-left: 20px !important;
}
.songNameContent {
  padding-left: 30px !important;
  min-width: 491px;
  overflow: hidden;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
.del_dialog {
  .head {
    width: 100%;
    height: 60px;
    background-color: #fff;
    line-height: 60px;
    padding-left: 20px;
    font-size: 20px;
    font-family: SourceHanSansCN-Normal;
    font-weight: 400;
    color: rgba(128, 124, 124, 1);
    border-bottom: 1px solid rgba(230, 230, 230, 1);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .body {
    width: 100%;
    height: 158px;
    background: rgba(255, 255, 255, 1);
    padding-top: 40px;
    p {
      font-size: 20px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      color: rgba(38, 33, 33, 1);
      width: 180px;
      height: 64px;
      margin: 0 auto;
      text-align: center;
    }
  }
  .foot {
    width: 100%;
    padding: 0 48px 48px 40px;
    background: rgba(255, 255, 255, 1);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    .sure,
    .cancel {
      width: 192px;
      height: 60px;
      border-radius: 12px;
      float: left;
      line-height: 60px;
      text-align: center;
      font-size: 20px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      cursor: pointer;
    }
    .sure {
      background: rgba(255, 64, 64, 1);
      color: rgba(254, 255, 254, 1);
    }
    .cancel {
      border: 1px solid rgba(204, 204, 204, 1);
      font-weight: 400;
      color: rgba(179, 175, 175, 1);
      float: right;
    }
  }
}

.audition_dialog /deep/ .el-dialog__header {
  padding: 0;
  height: 0;
}
.audition_dialog /deep/ .el-dialog {
  background-color: transparent;
  border-radius: 100px;
}

.audition_dialog /deep/.el-dialog__body {
  padding: 0;
  background-color: transparent;
  border-radius: 100px;
  height: 54px;
}
.del_dialog /deep/ .el-dialog__header {
  padding: 0;
  height: 0;
}
.del_dialog /deep/ .el-dialog {
  background-color: transparent;
  border-radius: 10px;
}

.del_dialog /deep/.el-dialog__body {
  padding: 0;
  background-color: transparent;
  border-radius: 10px;
}
.container {
  padding-top: 80px;
  min-height: 100%;
  background: rgba(250, 250, 250, 1);
  .main {
    width: 100%;
    padding: 0 130px;
    .title {
      margin-top: 16px;
      width: 100%;
      height: 68px;
      background: rgba(254, 255, 254, 1);
      border-radius: 10px;
      font-size: 28px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      color: rgba(38, 33, 33, 1);
      line-height: 68px;
      padding-left: 40px;
      margin-bottom: 8px;
    }
    .table {
      border-radius: 10px;
      overflow: hidden;
      background: rgba(254, 255, 254, 1);
      .edit {
        float: left;
        cursor: pointer;
        .edit_icon {
          width: 28px;
          height: 28px;
          background: url("../../assets/jlt_pc.png") no-repeat;
          background-size: 535px 314px;
          background-position: -29px -97px;
          float: left;
          margin-top: 16px;
        }
        span {
          line-height: 28px;
          padding-left: 12px;
          font-size: 20px;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          color: rgba(38, 33, 33, 1);
        }
      }
      .audition {
        float: left;
        margin-left: 40px;
        cursor: pointer;
        .audition_icon {
          width: 28px;
          margin-top: 16px;
          height: 28px;
          background: url("../../assets/jlt_pc.png") no-repeat;
          background-size: 535px 314px;
          background-position: -73px -97px;
          float: left;
        }
        span {
          line-height: 28px;
          padding-left: 12px;
          font-size: 20px;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          color: rgba(38, 33, 33, 1);
        }
      }
      .del {
        float: right;
        padding-right: 24px;
        cursor: pointer;
        .del_icon {
          width: 28px;
          height: 28px;
          margin-top: 16px;
          background: url("../../assets/jlt_pc.png") no-repeat;
          background-size: 535px 314px;
          background-position: -117px -97px;
          float: left;
        }
        span {
          font-size: 20px;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          color: rgba(255, 64, 64, 1);
          line-height: 28px;
        }
      }
    }
    .no_data {
      width: 100%;
      padding-top: 40px;
      padding-bottom: 20px;
      text-align: center;
      font-size: 20px;
      font-family: SourceHanSansCN-Normal;
      font-weight: 400;
      color: rgba(179, 175, 175, 1);
      line-height: 30px;
      background: rgba(254, 255, 254, 1);
    }
    // .table /deep/ th {
    //   background: rgba(240, 240, 240, 1);
    //   font-size: 20px;
    //   font-family: SourceHanSansCN-Medium;
    //   font-weight: 500;
    //   color: rgba(38, 33, 33, 1);
    // }
    // .table /deep/ tr {
    //   font-size: 20px;
    //   font-family: SourceHanSansCN-Medium;
    //   font-weight: 500;
    //   color: rgba(128, 124, 124, 1);
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product.vue